module.exports = __webpack_public_path__ + "static/media/aw.83f79639.jpeg";